import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['checkinTime']

  checkinDate = ''

  updateCheckoutTime() {
    // Calendar fires change event multiple times so we make sure there was an actual change before doing anything
    if (this.checkinTimeTarget.value && this.checkinTimeTarget.value != this.checkinDate) {
      this.checkinDate = this.checkinTimeTarget.value
      const datepicker = document.getElementById('datepicker')
      const url = $(datepicker).data('url')
      const resourceId = $(datepicker).data('resourceId')

      $.get({
        url: url,
        data: {
          id: resourceId,
          min_date: this.checkinDate
        }
      })
    }
  }
}
